import { gql } from '@apollo/client';
import { USER_FIELDS } from './fragments';

export const LOGIN = gql`
    ${USER_FIELDS}
    mutation login($email: String, $password: String) {
        login(email: $email, password: $password) {
            ...UserFields
        }
    }
`;
